export const GET_ALL_CARD_DETAILS = 'GET_ALL_CARD_DETAILS'
export const GET_CARD_DETAILS = 'GET_CARD_DETAILS'
export const GET_ALL_CARD_LINK = 'GET_ALL_CARD_LINK'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
